// @flow
import React from 'react';
import { Link } from '@reach/router';
// import theme from '../theme';

// const isActive = ({ isCurrent }) => {
//   return isCurrent ? { className: 'active' } : {};
// };

const NavLink = ({ activeMatch, ...props }) => (
  <div className="nav-wrap">
    <Link
      {...props}
      getProps={LinkProp => {
        const isCurrent = LinkProp.location.pathname.indexOf(activeMatch) > -1;
        return {
          className: isCurrent ? 'active' : ''
        };
      }}
    />
  </div>
);

export default NavLink;

export const SidebarNavLink = ({ activeMatch, isPrivate, ...props }) => {
  return (
    <Link
      {...props}
      getProps={LinkProp => {
        const isCurrent = LinkProp.location.pathname.indexOf(activeMatch) > -1;
        return {
          style: {
            background: isCurrent ? 'var(--color-smoke-50)' : 'transparent',
            color: isCurrent ? 'var(--base-color' : 'var(--secondary-color)',
            borderRadius: '3px',
            // boxShadow: isCurrent ? '0 0 4px 0 #cedbe8' : 'none',
            fontWeight: '500',
            display: 'flex',
            fontSize: '14px',
            height: '40px',
            textAlign: 'left',
            paddingLeft: '20px',
            alignItems: 'center',
            margin: 'auto'
          }
        };
      }}
    />
  );
};
